import { Link, useSearchParams } from "react-router";
import { routes } from "../../app/routes";
import { PageShell } from "../../platform/ui/PageShell";
import { StateMessage } from "../../platform/ui/StateMessage";
import { ContactForm } from "./ContactForm";
import { EnquiryForm } from "./EnquiryForm";
import "./contact.css";

const TURNSTILE_SITE_KEY: string | undefined = import.meta.env.VITE_TURNSTILE_SITE_KEY;

export function ContactPage() {
  const [params] = useSearchParams();
  const listingSlug = params.get("listing");
  return (
    <PageShell
      eyebrow="Straight to her inbox"
      title={listingSlug ? "Enquire with Orla" : "Email Orla"}
      layout="viewport"
      lead="Write here and Orla collects it herself. Her reply comes from her own address."
    >
      {TURNSTILE_SITE_KEY ? (
        listingSlug ? (
          <EnquiryForm key={listingSlug} slug={listingSlug} turnstileSiteKey={TURNSTILE_SITE_KEY} />
        ) : (
          <ContactForm turnstileSiteKey={TURNSTILE_SITE_KEY} />
        )
      ) : (
        <StateMessage tone="error" title="The contact form is not set up on this build">
          No spam-check key was given when the site was built, so messages cannot be sent from here.
        </StateMessage>
      )}
      <p className="contact-privacy">
        Your message is held privately until Orla collects and handles it.{" "}
        <Link to={routes.privacy()}>How your message is handled</Link>.
      </p>
    </PageShell>
  );
}
